const defaultApiUrl: string | undefined = import.meta.env.REACT_APP_ROADIE_API_URL
let apiUrl = defaultApiUrl

function canUseCustomApi() {
  return Boolean(import.meta.env.REACT_APP_CAN_USE_CUSTOM_API) || import.meta.env.MODE === 'test'
}

export function isApiCustomized() {
  return apiUrl !== defaultApiUrl
}

export function setApi(url: string) {
  if (!canUseCustomApi()) {
    return
  }

  sessionStorage.setItem('api-base', url)
  apiUrl = url
}

export function restoreApi() {
  if (!canUseCustomApi()) {
    return
  }

  const storedApiUrl = sessionStorage.getItem('api-base')
  if (storedApiUrl) {
    apiUrl = storedApiUrl.startsWith('http') ? storedApiUrl : `https://${storedApiUrl}`
  }
}

export function clearApi() {
  sessionStorage.removeItem('api-base')
  apiUrl = defaultApiUrl
}

export function getApi() {
  if (!apiUrl) {
    throw new Error('API URL is not set.')
  }

  return apiUrl
}
